export default [
  {
    url: '/basic/notice-board',
    name: 'Dashboard',
    icon: 'MonitorIcon',
    slug: 'dashboard',
    i18n: 'Notice Board',
  },
  ...['NZ', 'AU'].includes(process.env.VUE_APP_REGION) ? [
    {
      url: '/basic/shop',
      name: 'Shop',
      icon: 'ShoppingBagIcon',
      slug: 'shop',
      permission: 'Shop',
      i18n: 'Products',
    },
    {
      url: '/basic/dispense-request',
      name: 'Dispense Request',
      icon: 'ListIcon',
      slug: 'dispense-request',
      i18n: 'Dispense Request',
      permission: 'Shop',
    },
    {
      url: '/basic/orders',
      name: 'My Orders',
      slug: 'orders',
      i18n: 'My Orders',
      permission: 'Shop',
      icon: 'TruckIcon',
    },
    {
      url: '/basic/invoices',
      name: 'Invoice Management',
      slug: 'invoice',
      i18n: 'Invoices',
      permission: 'Invoice',
      icon: 'DollarSignIcon',
    },
    {
      url: '/basic/pos',
      name: 'POS',
      slug: 'pos',
      i18n: 'POS',
      permission: 'POS',
      icon: 'DollarSignIcon',
    },
    {
      url: '/basic/insights',
      name: 'Insights',
      icon: 'BarChart2Icon',
      permission:'Insights',
      slug: 'insights',
      i18n: 'Insights',
    },
    {
      url: '/basic/events',
      name: 'Training & Events',
      icon: 'CalendarIcon',
      slug: 'events',
      i18n: 'Training & Events',
    },
    {
      url: '/basic/referral',
      name: 'Refer Someone to Fresh',
      slug: 'referral',
      i18n: 'Refer Someone to Fresh',
      icon: 'UserPlusIcon',
    },
    {
      header: 'Resource Hub',
      i18n: 'Resource Hub',
      items: [
        {
          url: '/basic/resources',
          name: 'Resources',
          icon: 'FolderIcon',
          slug: 'resources',
          i18n: 'Resources',
        },
      ],
    },
    {
      header: 'Compliance',
      permission: 'Compliance',
      i18n: 'Compliance',
      items: [
        {
          url: '/basic/drugbook',
          name: 'Drugbook',
          icon: 'BookIcon',
          slug: 'drugbook',
          permission: 'Drug',
          i18n: 'Drugbook',
        },
        {
          url: '/basic/inventory',
          name: 'Inventory',
          featherIcon: false,
          icon: 'kitchen',
          slug: 'inventory',
          i18n: 'Inventory',
          permission: 'Drug',
        },
        {
          url: '/basic/compliance',
          name: 'Compliance',
          icon: 'GridIcon',
          slug: 'compliance',
          permission: 'Invoice',
          i18n: 'Compliance Checks',
        },
      ],
    },
  ] : [
    {
      url: '/basic/events',
      name: 'Training & Events',
      icon: 'CalendarIcon',
      slug: 'events',
      i18n: 'Training & Events',
    },
    {
      url: '/basic/referral',
      name: 'Refer Someone to Fresh',
      slug: 'referral',
      i18n: 'Refer Someone to Fresh',
      icon: 'UserPlusIcon',
    },
    {
      url: '/basic/resources',
      name: 'Resources',
      icon: 'FolderIcon',
      slug: 'resources',
      i18n: 'Resources',
    },
    {
      url: '/basic/invoices',
      name: 'Invoice Management',
      slug: 'invoice',
      i18n: 'Invoices',
      permission: 'Invoice',
      icon: 'DollarSignIcon',
    },
    {
      url: '/basic/drugbook',
      name: 'Drugbook',
      icon: 'BookIcon',
      slug: 'drugbook',
      permission: 'Drug',
      i18n: 'Drugbook',
    },
    {
      url: '/basic/compliance',
      name: 'Compliance',
      icon: 'GridIcon',
      slug: 'compliance',
      permission: 'Invoice',
      i18n: 'Compliance Checks',
    },
    {
      url: '/basic/inventory',
      name: 'Inventory',
      icon: 'CreditCardIcon',
      permission: 'Drug',
      slug: 'inventory',
      i18n: 'Inventory',
    },
    {
      url: '/basic/shop',
      name: 'Shop',
      icon: 'ShoppingBagIcon',
      slug: 'shop',
      permission: 'Shop',
      i18n: 'Shop',
    },
    {
      url: '/basic/orders',
      name: 'My Orders',
      slug: 'orders',
      i18n: 'My Orders',
      permission: 'Shop',
      icon: 'TruckIcon',
    },
    {
      url: '/basic/pos',
      name: 'POS',
      slug: 'pos',
      i18n: 'POS',
      permission: 'POS',
      icon: 'DollarSignIcon',
    },
    {
      url: '/basic/consent-forms',
      name: 'Consent Forms',
      icon: 'ActivityIcon',
      slug: 'consent-forms',
      i18n: 'Consent Forms',
      permission: 'CustomConsentForm',
    },
  ],
  {
    header: 'Settings',
    icon: 'SettingsIcon',
    i18n: 'Settings',
    permission: 'Settings',
    items: [
      {
        url: '/basic/clinics',
        name: 'Clinics',
        slug: 'basic-clinics-management',
        i18n: 'Clinics',
        icon: 'HomeIcon',
      },
      {
        url: '/basic/staff',
        name: 'Staff',
        icon: 'UsersIcon',
        slug: 'staff',
        i18n: 'Staff',
      },
      ...['NZ', 'AU'].includes(process.env.VUE_APP_REGION) ? [
        {
          url: '/basic/consent-forms',
          name: 'Consent Forms',
          icon: 'ActivityIcon',
          slug: 'consent-forms',
          i18n: 'Consent Forms',
          permission: 'CustomConsentForm',
        },
      ] : [],
      {
        url: '/basic/settings/products-list',
        name: 'basic Products List',
        slug: 'basic-products-list',
        icon: 'CheckSquareIcon',
        i18n: 'Products List',
      },
      {
        url: '/basic/settings/custom-products-list',
        name: 'basic Custom Products List',
        slug: 'basic-custom-products-list',
        icon: 'CheckSquareIcon',
        i18n: 'Products List',
        permission: 'CustomProduct',
      },
      {
        url: '/basic/settings/treatment-areas',
        name: 'basic Treatment Areas',
        slug: 'basic-treatment-areas',
        icon: 'ShuffleIcon',
        i18n: 'Treatment Areas',
      },
    ],
  },
];
